//Library Imports
import { useEffect, useState } from "react";
import styled from "styled-components";
import { Tooltip } from "antd";

//Local Imports
import Logo from "../../../assets/img/xiqPlaceholder.jpg";
import { ReactComponent as Speed } from "../../../assets/img/icons/Speed.svg";
import Paragraph from "antd/es/typography/Paragraph";
import { DEFAULT_IMAGE_PLACEHOLDER } from "constants/index";
import { addCommaToNumber, getImageUrl } from "utils";
import Checkbox from "modules/Common/Components/Checkbox";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { useHistory } from "react-router";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
// import {
//   disableSpecificAudienceContact,
//   disableSpecificAudienceList,
//   setCampaignAudience,
// } from "../Audience/actions";

interface IUserItemProps {
  id?: string;
  list_id?: string;
  contact_id?: string;
  color?: string;
  name?: string;
  email?: string;
  profileImage?: string;
  company?: string | number;
  designation?: string;
  clicks?: number;
  classname?: string;
  hideEllipsis?: boolean;
  recipientMenu?: boolean;
  recipientCount?: number;
  listItemThumbnail1?: string;
  listItemThumbnail2?: string;
  listItemThumbnail3?: string;
  is_active?: string;
  showCheckbox?: boolean;
  hideScore?: boolean;
  status?: string;
  setUpdatedCampaignAudienceListsState?: (value: any[]) => void;
  setUpdatedCampaignAudienceContactsState?: (value: any[]) => void;
  setUpdatedCampaignAudienceListsStateIds?: (value: any[]) => void;
  setUpdatedCampaignAudienceContactsStateIds?: (value: any[]) => void;
  updatedContactObject?: any[];
  setUpdatedContactObject?: (value: any[]) => void;
  updatedListObject?: any[];
  setUpdatedListObject?: (value: any[]) => void;
  disabled?: boolean;
  sendToObjectCampaignAudience?: any[];
  setSendToObjectCampaignAudience?: (value: any[]) => void;
  addInSendTo?: (value: any) => void;
}

const UserItem: React.FC<IUserItemProps> = (props) => {
  // Local States
  const [switchValue, setSwitchValue] = useState(props?.is_active === "1" ? true : false);
  const [ellipsisState, setEllipsisState] = useState(false);
  const [contactsState, setContactsState] = useState<any[]>([]);
  const [listState, setListState] = useState<any[]>([]);

  // Redux States
  const campaignAudienceLists = useSelector((state: RootState) => state.campaignAudience.data.lists);
  const campaignAudienceContacts = useSelector((state: RootState) => state.campaignAudience.data.contacts);
  const sendToCampaignAudience = useSelector(
    (state: RootState) => state.campaignAudience.data.sendToCampaignAudience
  );

  const history = useHistory();

  // Component Logic
  useEffect(() => {
    if (campaignAudienceContacts && contactsState.length === 0) setContactsState(campaignAudienceContacts);
  }, [campaignAudienceContacts]);

  useEffect(() => {
    if (campaignAudienceLists && listState.length === 0) setListState(campaignAudienceLists);
  }, [campaignAudienceLists]);

  const addInSendToFunc = (value: any) => {
    if (props.list_id) {
      props.addInSendTo && props.addInSendTo(parseInt(props.list_id));
    } else {
      props.addInSendTo && props.addInSendTo(props.email);
    }

    // let audience = props.sendToObjectCampaignAudience || [];
    // if (props.list_id) {
    //   props.setSendToObjectCampaignAudience &&
    //     props.setSendToObjectCampaignAudience([
    //       ...audience,
    //       { value: parseInt(props.list_id), label: props.name },
    //     ]);
    //   //setCampaignAudience([...audience, { value: props.list_id, label: props.name }]);
    //   disableSpecificAudienceList(parseInt(props.list_id));
    // } else if (props.contact_id) {
    //   props.setSendToObjectCampaignAudience &&
    //     props.setSendToObjectCampaignAudience([
    //       ...audience,
    //       { value: props.email, label: props?.name?.trim() ? props.name : props.email },
    //     ]);
    //   disableSpecificAudienceContact(parseInt(props.contact_id));
    // }
  };

  const checkboxActionHandler = () => {
    setSwitchValue(!switchValue);
    if (props.list_id) {
      let clickedList = {};
      const updatedCampaignAudienceLists = listState.map((list: any) => {
        if (list.id.toString() === props?.list_id?.toString()) {
          list.is_active = list.is_active === 1 ? 0 : 1;
          clickedList = list;
        }
        return list;
      });
      props.setUpdatedCampaignAudienceListsState &&
        props.setUpdatedCampaignAudienceListsState(updatedCampaignAudienceLists);
      //console.log(updatedCampaignAudienceLists);
      setListState(updatedCampaignAudienceLists);

      const updatedCampaignAudienceListsIds = campaignAudienceLists
        .filter((list: any) => list.is_active.toString() === "1")
        .map((list: any) => list.id);

      props.setUpdatedCampaignAudienceListsStateIds &&
        props.setUpdatedCampaignAudienceListsStateIds(updatedCampaignAudienceListsIds);

      if (props.updatedListObject && props.updatedListObject.length === 0) {
        props.setUpdatedListObject && props.setUpdatedListObject([clickedList]);
      } else {
        let updatedListsObjectArray: any[] = [];
        let newListAdded = true;

        // this updates the active state of contacts
        const updatedLists =
          props.updatedListObject &&
          props.updatedListObject.map((list) => {
            if (list.id.toString() === props?.list_id?.toString()) {
              list.is_active = list.is_active;
              newListAdded = false;
              return list;
            }
            return list;
          });
        // this adds the new list in the array if it is not present already
        if (newListAdded) {
          updatedListsObjectArray = [...(updatedLists ? updatedLists : []), clickedList];
        } else {
          updatedListsObjectArray = updatedLists ? updatedLists : [];
        }
        // console.log(updatedListsObjectArray);

        props.setUpdatedListObject && props.setUpdatedListObject(updatedListsObjectArray);
      }
    }

    if (props.contact_id) {
      let clickedContact = {};
      const updatedCampaignAudienceContacts = contactsState.map((contact: any) => {
        if (contact.id.toString() === props?.contact_id?.toString()) {
          contact.is_active = contact.is_active === 1 ? 0 : 1;
          clickedContact = contact;
        }
        return contact;
      });
      props.setUpdatedCampaignAudienceContactsState &&
        props.setUpdatedCampaignAudienceContactsState(updatedCampaignAudienceContacts);
      setContactsState(updatedCampaignAudienceContacts);
      //console.log("updatedCampaignAudienceContacts", updatedCampaignAudienceContacts);

      const updatedCampaignAudienceContactsIds = updatedCampaignAudienceContacts
        .filter((contact: any) => contact.is_active === 1 && contact.status === "Subscribed")
        .map((contact: any) => contact.id);
      props.setUpdatedCampaignAudienceContactsStateIds &&
        props.setUpdatedCampaignAudienceContactsStateIds(updatedCampaignAudienceContactsIds);
      //console.log("updatedCampaignAudienceContactsIds", updatedCampaignAudienceContactsIds);

      if (props.updatedContactObject && props.updatedContactObject.length === 0) {
        props.setUpdatedContactObject && props.setUpdatedContactObject([clickedContact]);
      } else {
        let updatedContactsObjectArray: any[] = [];
        let newContactAdded = true;

        // this updates the active state of contacts
        const updatedContacts =
          props.updatedContactObject &&
          props.updatedContactObject.map((contact) => {
            if (contact.id.toString() === props?.contact_id?.toString()) {
              contact.is_active = contact.is_active;
              newContactAdded = false;
              return contact;
            }
            return contact;
          });

        // this adds the new contact in the array if it is not present already
        if (newContactAdded) {
          updatedContactsObjectArray = [...(updatedContacts ? updatedContacts : []), clickedContact];
        } else {
          updatedContactsObjectArray = updatedContacts ? updatedContacts : [];
        }

        props.setUpdatedContactObject && props.setUpdatedContactObject(updatedContactsObjectArray);
      }
    }
  };
  //console.log("contactsState", contactsState);
  useEffect(() => {
    setSwitchValue(props?.is_active === "1" ? true : false);
  }, [props?.is_active, props.name]);

  const nameDisplay =
    props.name?.trim() === "" || props.name === null || props.name === undefined ? props.email : props.name;

  const redirectToList = (e: any, listId?: string) => {
    e.preventDefault();
    e.stopPropagation();
    history.push(
      `/audiences/lists/view?list_id=${listId}&from=publish&campaign_id=${getQueryCampaignId()}&email_id=${getQueryEmailId()}&asiderOpen=true`
    );
  };

  return (
    <Wrapper
      color={props?.color}
      className={`${props.classname === undefined ? "" : props.classname} ${props.disabled ? "disabled" : ""}`}
      data-user-single="user-item"
      onClick={addInSendToFunc}
    >
      {props.showCheckbox && (
        <span className={"checkbox"} data-qa="qa-checbox-aside">
          <Checkbox onChange={checkboxActionHandler} checked={switchValue} width="18px" height="18px" />
        </span>
      )}
      {props.recipientCount ? (
        <div className="blog-image">
          {props.listItemThumbnail1 ? (
            <div
              className="img1 img-bg"
              style={{
                backgroundImage: `url(${props.listItemThumbnail1 || DEFAULT_IMAGE_PLACEHOLDER})`,
              }}
            />
          ) : (
            <img
              className="img1"
              src={props.listItemThumbnail1 || "https://media.xiq.io/static/default_campaign_img.png"}
              alt="img1"
              style={{ borderColor: props?.color ? props?.color : "#ffffff" }}
            />
          )}

          <div className="right-images">
            {props.listItemThumbnail2 ? (
              <div
                className="img2 img-bg"
                style={{
                  backgroundImage: `url(${props.listItemThumbnail2 || DEFAULT_IMAGE_PLACEHOLDER})`,
                }}
              />
            ) : (
              <img
                className="img2"
                src={props.listItemThumbnail2 || "https://media.xiq.io/static/default_campaign_img.png"}
                alt="img2"
              />
            )}

            {props.listItemThumbnail3 ? (
              <div
                className="img3 img-bg"
                style={{
                  backgroundImage: `url(${props.listItemThumbnail3 || DEFAULT_IMAGE_PLACEHOLDER})`,
                }}
              />
            ) : (
              <img
                className="img3"
                src={props.listItemThumbnail3 || "https://media.xiq.io/static/default_campaign_img.png"}
                alt="img3"
              />
            )}
          </div>
        </div>
      ) : (
        <div className="preview">
          <img
            src={props.profileImage ? props.profileImage : Logo}
            alt=""
            onError={(e: any) => {
              e.target.onerror = null;
              e.target.src = Logo;
            }}
          />
        </div>
      )}
      <div className="details">
        {props.recipientCount ? (
          <>
            <div className="list-name">
              <Tooltip
                placement="top"
                title={
                  props.name?.trim() === "" || props.name === null || props.name === undefined
                    ? props.email
                    : props.name
                }
              >
                {props.name?.trim() === "" || props.name === null || props.name === undefined
                  ? props.email
                  : props.name}
              </Tooltip>
            </div>
            <div className="recipient-count">{`${props.recipientCount} recipient(s)`}</div>
          </>
        ) : (
          <>
            <Tooltip title={ellipsisState ? nameDisplay : undefined}>
              <Paragraph className="name" data-qa="qa-aside-name" ellipsis={{ onEllipsis: setEllipsisState }}>
                {nameDisplay}
              </Paragraph>
            </Tooltip>
            <div className="company">{props.company}</div>
            <div className="designation">{props.designation}</div>
          </>
        )}
      </div>
      {props.list_id ? (
        <div className="view-list" onClick={(e) => redirectToList(e, props.list_id)}>
          View List
        </div>
      ) : null}
      {(!props.hideScore || props.status === "Unsubscribed" || props.status === "Hard Bounce") && (
        <div className="actions d-flex justify-content-end">
          {!props.hideScore && (
            <ul className="d-flex justify-content-end">
              <li className="clicks">
                <span className="container-span d-flex justify-content-between">
                  <Speed />
                  <span>{addCommaToNumber((props?.clicks ?? 0).toString() ?? "")}</span>
                </span>
              </li>
            </ul>
          )}
          {(props.status === "Unsubscribed" || props.status === "Hard Bounce") && (
            <ul className="d-flex justify-content-end">
              <li className={props.status === "Hard Bounce" ? "unsubText bounceColor" : "unsubText"}>
                <span className="container-span d-flex justify-content-center">{props.status}</span>
              </li>
            </ul>
          )}
        </div>
      )}
    </Wrapper>
  );
};

export default UserItem;

const Wrapper = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
  margin-bottom: 10px;
  padding: 14px 13px 14px 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 7px;
    padding: 10px 12px;
    max-height: 83px;
    min-height: 83px;
  }
  .view-list {
    margin-left: auto;
    background-color: #001760;
    padding: 5px 10px;
    border-radius: 15px;
    color: #fff;
    font-size: 12px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    margin-right: 4px;
    min-width:fit-content;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 4px 8px;
      font-size: 10px;
    }
  }
  .checkbox {
    margin-right: 10px;
  }
  .blog-image {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .blog-image {
    .img1 {
      height: 70px;
      width: 52px;
      border-radius: 6px 0px 0px 6px;
      margin-right: 2px;
      @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
        border-radius: 4px 0px 0px 4px;
        height: 50px;
        width: 36px;
      }
    }
    .img-bg {
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .right-images {
      .overlayed-image {
        position: absolute;
        left: 9%;
        top: 22%;
      }
      .img-bg {
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
      }
      display: flex;
      flex-direction: column;
      .img2 {
        height: 34px;
        width: 39px;
        border-radius: 0px 6px 0px 0px;
        margin-bottom: 1px;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 0px 4px 0px 0px;
          height: 25px;
          width: 28px;
        }
      }
      .img3 {
        height: 34px;
        width: 39px;
        border-radius: 0px 0px 6px 0px;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          border-radius: 0px 0px 4px 0px;
          height: 23px;
          width: 28px;
        }
      }
    }
  }
  .disabled {
    pointer-events: none !important;
    background-color: rgba(225, 225, 225, 0.7) !important;
    cursor: no-drop;
  }
  .preview {
    position: relative;
    max-width: 55px;
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
    img {
      border-radius: 100%;
      box-shadow: ${(props) => (props.color ? `0px 0px 0px 2px ${props.color}` : "")};
      max-width: 100%;
      height: 51px;
      width: 51px;
      min-width: 51px;
      outline: none;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 36px;
        width: 36px;
        min-width: 36px;
      }
    }
  }
  .details {
    padding-left: 15px;
    .name,
    .company,
    .designation,
    .recipient-count {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 0px;
      -webkit-box-align: start;
      width: 100%;
      word-break: break-word;
    }
    .name {
      color: #000000;
      font-size: 20px;
      font-weight: 500;
      line-height: 22px;
      font-family: "Roboto Slab", serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 15px;
        font-size: 13px;
      }
    }
    .list-name {
      color: #000000;
      font-size: 20px;
      font-weight: 400;
      line-height: 22px;
      font-family: "Roboto Slab", serif;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;

      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 14px;
        font-size: 13px;
      }
    }
    .company {
      -webkit-line-clamp: 1;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: #424b50;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 9px;
      }
    }
    .designation {
      -webkit-line-clamp: 1;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      line-height: 16px;
      font-size: 14px;
      color: #27ce0a;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 9px;
      }
    }
    .recipient-count {
      -webkit-line-clamp: 1;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      line-height: 16px;
      font-size: 14px;
      color: #27ce0a;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        line-height: 18px;
        font-size: 9px;
      }
    }
  }
  .actions {
    -ms-flex-negative: 1;
    flex-shrink: 1;
    align-self: center;
    margin-left: auto;
    min-width: 106px;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      width: 100%;
      li {
        float: left;
        display: inline-block;
        padding: 0px;
        &.clicks {
          padding-right: 10px;
          .container-span {
            font-family: "Roboto", sans-serif;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            background-color: #1971eb;
            border-radius: 12px;
            padding: 0px 10px;
            display: inline-flex;
            min-width: 80px;
            height: 22px;
            justify-content: center;
            align-items: center;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 11px;
              width: 70px;
            }
            svg {
              vertical-align: baseline;
              margin-right: 5px;
            }
          }
        }
        &.card-popover {
          a {
            padding: 0 5px;
            svg {
              width: 5px;
              max-height: none;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                width: 3px;
              }
            }
          }
        }
      }
    }
  }
  .unsubText {
    background: #ffe2e4;
    border: 1px solid #dadada;
    border-radius: 10px;
    display: flex;
    align-items: center;
    span {
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      font-size: 10px;
      line-height: 11px;
      letter-spacing: -0.236842px;
      color: #f5222d;
      min-width: 75px;
      min-height: 20px;
      align-items: center;
    }
  }
  .bounceColor {
    background: rgb(255, 149, 49, 0.2) !important;
    span {
      color: rgb(255, 149, 49) !important;
    }
  }
`;
